import React from 'react';
import './jh.css';

function Contatojh() {
  return (
    <section id="contato-jh">
      <div className="container text-center">
        <div className="row justify-content-center mb-3">
          <div className="col-12">
            <p className="cnpj-jh">JH TRANSPORTE DE MINÉRIOS LTDA - CNPJ: 59.711.198/0001-64</p>
            <p className="endereco-jh">
              AV. BARÃO DE VERA CRUZ, 188, BOX C, CRUZ DE REBOUÇAS, IGARASSU – PE. CEP. 53.625-015
            </p>
          </div>
        </div>
        <div className="row justify-content-center">
          <ul className="list-unstyled list-inline social">
            <li className="list-inline-item mx-2">
              <a href="https://api.whatsapp.com/send?phone=5581988823062" target="_blank" rel="noreferrer">
                <i className="fa fa-whatsapp fa-3x icon-light"></i>
              </a>
            </li>
            <li className="list-inline-item mx-2">
              <a href="https://www.instagram.com/jhminerios/" target="_blank" rel="noreferrer">
                <i className="fa fa-instagram fa-3x icon-light"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Contatojh;
